
import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { useDispatch,useSelector } from "react-redux";
import authActions from "../../redux/auth/actions";
import candidatesActions from "../../redux/candidates/actions";
import Cookies from "js-cookie";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Grid,
} from "@mui/material";
import PrimaryButton from "../../common/button/primaryButton";
import commonActions from "../../redux/common/actions";
import { useNavigate } from "react-router-dom";

const CommonOtpVerification = ({ open, setOpen,mobileNumber }) => {
  const dispatch = useDispatch();
  const navigate=useNavigate();
  const [otp, setOtp] = useState("");
  const [resendCountdown, setResendCountdown] = useState(0);
  const [attempt, setAttempt] = useState(0);
  const [wrongOTP, setWrongotp] = useState(0);
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [timer, setTimer] = useState(null);
  const [mobileVerified, setMobileVerified] = useState(false);

  const courseid = localStorage.getItem("courseid");
  const coursename = localStorage.getItem("coursename");
const otpVerified = useSelector(state => state.authReducer.otpVerified);
const [isVerifying, setIsVerifying] = useState(false);

 

  useEffect(() => {
    if (resendCountdown > 0) {
      const t = setTimeout(() => setResendCountdown(resendCountdown - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [resendCountdown]);
 

  const startTimer = (initialTime = 1800) => {
    if (timer) clearInterval(timer);
    const newTimer = setInterval(() => {
      setTimeRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(newTimer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    setTimer(newTimer);
    setTimeRemaining(initialTime);
  };
useEffect(() => {
  if (!isVerifying) return;
  if (otpVerified === true) {
    dispatch({
  type: candidatesActions.SET_STATUS,
  payload: true
});
localStorage.setItem("status", true);
    dispatch({
      type: candidatesActions.GET_BYPASS_REGISTRATION,
      payload: {
        navigate,
        courseid,
        coursename,
        callback: () => {
              dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
            },
      },
    });
    setOpen(false); // close dialog
    setMobileVerified(true); // update state

  } 
  // setIsVerifying(false);
}, [otpVerified, dispatch,isVerifying]);

  const handleResend = () => {
    setOtp("");
    setResendCountdown(120);
    dispatch({
      type: authActions.SEND_OTP_FOR_MOBILE_VERIFICATION,
      payload: {
        data: {
          mobileno: mobileNumber,
        },
      },
    });
    if (attempt < 5) setWrongotp(0);
    setAttempt((prev) => prev + 1);
  };

  const handleVerify = () => {
    //  
    if (otp.length !== 6) return;
    setIsVerifying(true);
    
    // dispatch({ type: commonActions.VERIFY_OTP });
    dispatch({type:authActions.VERIFY_OTP,payload:{otp:otp,mobileno:mobileNumber,courseid:courseid,coursename:coursename,setOpen:setOpen,setMobileVerified:setMobileVerified,setWrongotp:setWrongotp,navigate}})
  //   else {
  //   setWrongotp((prev) => prev + 1);
  // }
    
    // if (otp === otpValue) {
    //   setMobileVerified(true);
    //   localStorage.setItem("otpverified", "true");
    //   setOpen(false);
    //   dispatch({
    //     type: candidatesActions.GET_BYPASS_REGISTRATION,
    //     payload: {
    //       courseid,
    //       coursename,
    //       navigate,
    //     callback: () => {
    //           dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
    //         },
    //     },
    //   });
    // } else {
      // setWrongotp((prev) => prev + 1);
    // }
  };
useEffect(() => {
  if (open) {
    setResendCountdown(120); 
  }
}, [open]);
  return (
    <Dialog open={open} fullWidth maxWidth="sm" PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle textAlign="center" sx={{ marginTop:"5vh",fontWeight: 600, fontSize: "20px" }}>
       
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          sx={{ minHeight: "30vh" }}
        >
           <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "20px",
                          fontWeight: 500,
                          lineHeight: "24.2px",
                          textAlign: "center",
                        }}
                      >
                        Mobile verification
                      </Typography>
                      <Typography
                        mt={2}
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "20px",
                          textAlign: "center",
                        }}
                      >
                        {" "}
                        We have sent an OTP to your registered phone number. Enter the OTP
                        below
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "14px",
                          fontWeight: 400,
                          lineHeight: "20px",
                          textAlign: "center",
                        }}
                      >
                        {" "}
                        to verify your phone number.
                      </Typography>

          <Typography mt={2} fontWeight={700} fontSize="16px">
            {mobileNumber}
          </Typography>

          <Box my={3}>
            <OTPInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              renderInput={(props) => (
                <input
                  {...props}
                  style={{
                    width: "38px",
                    height: "40px",
                    margin: "5px",
                    borderRadius: "8px",
                    border: "2px solid #BDD8FE",
                    textAlign: "center",
                    fontSize: "18px",
                  }}
                />
              )}
            />
          </Box>

          {wrongOTP > 0  && (
            <Typography color="red" mb={1}>
              Wrong OTP entered ({wrongOTP} / 5)
            </Typography>
          )}

          <PrimaryButton
            text="Verify"
            handleClick={handleVerify}
            disabled={otp.length !== 6 || wrongOTP >= 5}
          />

          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            mt={3}
            mb={3}
            width="100%"
            px={3}
          >
            
             {resendCountdown > 0 ? (
  <Typography fontSize="14px" color="gray">
    RESEND OTP IN ({resendCountdown}) SEC
  </Typography>
) : (
  <Typography
    fontSize="14px"
    sx={{ color: "#1976d2", cursor: "pointer", fontWeight: "bold" }}
    onClick={handleResend}
  >
    RESEND OTP
  </Typography>
)}
            
            <Typography fontSize="14px" fontWeight="bold" color="#1976d2">
              {attempt} / 5
            </Typography>

            
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default CommonOtpVerification;


